import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { Link } from "@tanstack/react-router"
import { string } from "prop-types"

function ErrorPage({ message }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 2,
        textAlign: "center",
        px: 4
      }}
    >
      <Typography variant="h4" color="error">
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {message || "An unexpected error occurred. Try reloading the page or heading back home."}
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
        <Button variant="contained" component={Link} to="/">
          Go home
        </Button>
        <Button variant="outlined" onClick={() => globalThis.location.reload()}>
          Reload page
        </Button>
      </Box>
    </Box>
  )
}

ErrorPage.propTypes = {
  message: string
}

export default ErrorPage
